import React from 'react';
import { Hero } from './components/Hero';
import { ServicesSection } from './components/ServicesSection';
import { TestimonialsCarousel } from './components/TestimonialsCarousel';
import { FeaturedTestimonial } from './components/FeaturedTestimonial';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PaymentMethods } from './components/PaymentMethods';
import { ConsultationForm } from './components/ConsultationForm';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
interface AppProps {
  /** Order of the page: proof-first puts the testimonials above the services. */
  proofFirst?: boolean;
}
export function App({
  proofFirst = false
}: AppProps) {
  return <div className="min-h-full w-full bg-ink text-white" data-id="element-0" data-mp="28tw4ipctkg2e">
      <Hero data-id="element-1" data-mp="28sb9kymlev40" />

      {proofFirst ? <>
          <TestimonialsCarousel data-id="element-2" data-mp="23w4clvc6cty7" />
          <ServicesSection data-id="element-3" data-mp="23v2rsz5cwt3a" />
        </> : <>
          <ServicesSection data-id="element-4" data-mp="3ikqwvtvkeu33" />
          <TestimonialsCarousel data-id="element-5" data-mp="3ijfthv617oci" />
        </>}

      <FeaturedTestimonial data-id="element-6" data-mp="3ml14faz09sk2" />
      <GuaranteeSection data-id="element-7" data-mp="3mk8710lxsfel" />
      <PaymentMethods data-id="element-8" data-mp="3mjpyb4i388ps" />
      <ConsultationForm data-id="element-9" data-mp="3rc9e8848zfxr" />
      <FinalCta data-id="element-10" data-mp="3rbzn2h7gv2qh" />
      <Footer data-id="element-11" data-mp="3rdatypw7kqlt" />

      <FloatingWhatsApp data-id="element-12" data-mp="3rcsxbs5mwadd" />
    </div>;
}